import { render, staticRenderFns } from "./juniorSchool.vue?vue&type=template&id=121c26c3&"
import script from "./juniorSchool.vue?vue&type=script&lang=js&"
export * from "./juniorSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports